import { sessionOrMemoryStorage } from '@vista-digital/utilities';
import { getUuid } from './get-uuid';
const sessionIdStorageKey = 'VistaOcapiClient::session-id';
/**
 * Returns a unique session ID used for logging via the [[OcapiHeader.CorrelationId]] API header.
 * Gets the session ID from sessionStorage if it exists, or creates and stores a new ID.
 */
export const getSessionId = () => {
    const existingSessionId = sessionOrMemoryStorage.getItem(sessionIdStorageKey);
    if (existingSessionId) {
        return existingSessionId;
    }
    const sessionId = getUuid();
    sessionOrMemoryStorage.setItem(sessionIdStorageKey, sessionId);
    return sessionId;
};
//# sourceMappingURL=get-session-id.js.map